<cx-view class="card">
  @if (form$ | async; as form) {
    <form [formGroup]="form" (submit)="save(form)">
      <div class="header">
        <div class="title-bar">
          <div class="title">
            <h3>
              {{"organization.changePassword.title" | cxTranslate }}
            </h3>
            <h4>{{"organization.changePassword.subtitle" | cxTranslate }}{{userID}}</h4>
          </div>
          <div class="actions">
            <button actions="" class="btn btn-secondary" type="submit"  [disabled]="form.invalid">  {{ "organization.save" | cxTranslate }} </button>
            <a class="link close" routerLink="../">
              <cx-icon
                type="CLOSE"
              ></cx-icon>
            </a>
          </div>
        </div>
      </div>
      <div class="main">
        <span class="passwordSpecs" [innerHTML]="'organization.changePassword.passwordSpecs' | cxTranslate"></span>
        <section main class="details">
          <label class="full-width">
            <span class="label-content">{{
              "orgUser.password.newPassword" | cxTranslate
            }}</span>
            <input
              class="form-control"
              type="password"
              name="password"
              placeholder="{{ 'orgUser.password.newPassword' | cxTranslate }}"
              formControlName="password"
              />
              <cx-form-errors [control]="form.get('password')"></cx-form-errors>
            </label>
            <label>
              <span class="label-content">{{
                "orgUser.password.confirmPassword" | cxTranslate
              }}</span>
              <input
                class="form-control"
                type="password"
                name="confirmPassword"
                placeholder="{{ 'orgUser.password.confirmPassword' | cxTranslate }}"
                formControlName="confirmPassword"
                />
                <cx-form-errors
                  [control]="form.get('confirmPassword')"
                ></cx-form-errors>
              </label>
            </section>
          </div>
        </form>
      }
    </cx-view>
